import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
];

export default function LandingNav() {
  const [open, setOpen] = useState(false);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className="sticky top-0 z-50 border-b backdrop-blur-sm"
      style={{ backgroundColor: 'rgba(255,255,255,0.95)', borderColor: '#D7E2E8' }}
      data-testid="landing-nav"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 h-16">
        {/* Logo */}
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-2.5" data-testid="landing-nav-logo">
          <img src="/brand/logo-round.png" alt="" className="w-8 h-8 rounded-full" />
          <span className="text-lg font-extrabold" style={{ color: '#5B2D1F' }}>Heritage Compass</span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-6">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className="text-sm font-semibold transition-colors hover:opacity-70"
              style={{ color: '#5B2D1F' }}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/signin"
            data-testid="landing-nav-signin"
            className="text-sm font-bold px-4 py-2 rounded-lg transition-opacity hover:opacity-80"
            style={{ color: '#D77A52' }}
          >
            Sign in
          </Link>
          <Link
            to="/signup"
            data-testid="landing-nav-signup"
            className="text-sm font-extrabold px-5 py-2.5 rounded-lg text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#D77A52' }}
          >
            Create account
          </Link>
        </div>

        {/* Mobile menu button */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 rounded-lg hover:bg-black/5"
          data-testid="landing-nav-menu-btn"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" style={{ color: '#5B2D1F' }} /> : <Menu className="h-6 w-6" style={{ color: '#5B2D1F' }} />}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden border-t px-4 pb-4 pt-2 space-y-2" style={{ borderColor: '#D7E2E8', backgroundColor: '#FFFFFF' }}>
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => scrollTo(e, l.href)}
              className="block py-2 text-base font-semibold"
              style={{ color: '#5B2D1F' }}
            >
              {l.label}
            </a>
          ))}
          <div className="flex gap-2 pt-2">
            <Link to="/signin" className="flex-1 text-center py-3 rounded-lg text-base font-bold border-2" style={{ borderColor: '#D77A52', color: '#D77A52' }}>Sign in</Link>
            <Link to="/signup" className="flex-1 text-center py-3 rounded-lg text-base font-extrabold text-white" style={{ backgroundColor: '#D77A52' }}>Create account</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
